import {Component, OnDestroy, OnInit, Input, ChangeDetectionStrategy} from '@angular/core';
import { UserCacheService } from '../../../common/services/user-cache.service';
import { AppConstants } from '../../../common/constants/app-constants';
import { DataService } from '../../../common/services/data.service';
import { FwcModal } from '../../../../fwc-lib.js';
import { Subscription } from 'rxjs';

@Component({
    selector: 'sae-global-footer',
    templateUrl: './global-footer.component.html',
    styleUrls: ['./global-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GlobalFooterComponent implements OnInit, OnDestroy {
  @Input() stories: any;
  footer: {
    privacy: string,
    legal: string,
    contactInfo: any
  } = null;
  private dataSubscription: Subscription;
  changeStorySubscription: any;
  brandTagline: any;
  constructor(
    public userCacheService: UserCacheService,
    public dataService: DataService
  ){
    this.footer = userCacheService.getUserData(AppConstants.GLOBAL_FOOTER);
    this.dataSubscription = dataService.announcement.subscribe(announce => {
      if (announce != null && announce.topic === AppConstants.GLOBAL_FOOTER) {
        this.footer = announce.message;
      }
    });
    const fwcModal = new FwcModal();
    fwcModal.build();
  }
  ngOnInit(): void {
			this.changeStorySubscription = this.dataService.changeStoryInstance.subscribe(data => {
      if (data.storyId) {
        if (data && this.stories) {
          const selectedStory = this.stories.filter(x => parseInt(x.id) === parseInt(data.storyId))[0];
          this.setBrandFooter(selectedStory);
        }
        // let selectedOption = this.searchOptions.filter(x => x.id === data)[0];
      }
    });
    if (this.stories) {
      this.setBrandFooter(this.stories[0]);
    }
  }
  
   private setBrandFooter(selectedStory: any) {
    this.brandTagline = selectedStory.brandTagline;
   }

  ngOnDestroy(): void {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }
  openModal(): void {
    const modal = document.getElementById('contactModal');
    modal.setAttribute('open', '');
  }

  closeModal(): void {
    const modal = document.getElementById('contactModal');
    modal.removeAttribute('open');
  }
}
